import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import fileUpload from '../../../utils/fileUpload';
import deleteFile from '../../../utils/deleteFile';
import { supTripCreateFun, supTripEdit } from '../../../api/supportAdmin';

export default async function supPackUpSubmit(
    packData,
    tempData,
    imgData,
    setLoading,
    isEdit,
    orgId,
    videoFile,
    refs = {}
) {
    if (!packData.group || packData.group === '-1' || packData.group === '') {
        toast.error('Please select group type');
        refs.basicRef?.current?.scrollToAndHighlightField('group');
        return;
    }

    if (packData.datesType === '-1' || packData.datesType === '') {
        toast.error('Please select date type');
        refs.basicRef?.current?.scrollToAndHighlightField('datesType');
        return;
    }
    if (3 > packData.title.length || packData.title.length > 50) {
        toast.error('Title error');
        refs.basicRef?.current?.scrollToAndHighlightField('title');
        return;
    } else if (50 > packData.overview.length || packData.overview.length > 4000) {
        toast.error('Overview error');
        refs.basicRef?.current?.scrollToAndHighlightField('overview');
        return;
    } else if (1 > packData.days || packData.days > 99) {
        toast.error('Days should be greater than 0');
        refs.basicRef?.current?.scrollToAndHighlightField('days');
        return;
    }
    //As a trip can be for one day only.
    else if (packData.nights < 0 || packData.nights > 99) {
        toast.error('Nights must be between 0 and 99');
        refs.basicRef?.current?.scrollToAndHighlightField('nights');
        return;
    }
    //check each key value pair in quickview for empty string
    const quickView = packData.quickView;

    if (!Array.isArray(quickView.type) || quickView.type.length === 0) {
        toast.error('Type must be a non-empty array.');
        refs.quickViewRef?.current?.scrollToAndHighlightField('type');
        return;
    }

    const hasInvalidTypeItems = quickView.type.some((item) => typeof item !== 'string' || item.trim() === '');

    if (hasInvalidTypeItems) {
        toast.error('Type contains empty or invalid items.');
        refs.quickViewRef?.current?.scrollToAndHighlightField('type');
        return;
    }

    // 2. Validate other fields (stop at first error)
    const fieldsToValidate = [
        'difficulty',
        'startTime',
        'endTime',
        'duration',
        'stay',
        'where',
        'food',
        'trekDistance',
        'baseCities'
    ];

    for (const field of fieldsToValidate) {
        const value = quickView[field];

        const isEmptyString = typeof value === 'string' && value.trim() === '';
        const isInvalidStringValue = value === '-1';
        const isNullOrUndefined = value === null || value === undefined;

        if (isEmptyString || isInvalidStringValue || isNullOrUndefined) {
            const label = field.charAt(0).toUpperCase() + field.slice(1).replace(/([A-Z])/g, ' $1');

            toast.error(`Quickview ${label} is required.`);
            refs.quickViewRef?.current?.scrollToAndHighlightField(field);
            return;
        }
    }

    // .every return a boolean value. We check the condition and if its false
    //thers is some problem in itinerary.
    //for loop and forEach will not work as they cant return the outer function
    //they only return out from the loop.
    const itinerary = packData.itinerary;

    if (packData.itiType === '-1' || packData.itiType === '') {
        toast.error('Please select itinerary type');
        refs.itineraryRef?.current?.scrollToAndHighlightField('itiType');
        return;
    }
    if (!Array.isArray(itinerary) || itinerary.length === 0) {
        toast.error('Itinerary must have at least one day.');
        refs.itineraryRef?.current?.scrollToAndHighlightField('itinerary');
        return;
    }

    for (let i = 0; i < itinerary.length; i++) {
        const day = itinerary[i];

        if (typeof day.dayHeading !== 'string' || day.dayHeading.trim() === '') {
            toast.error(`Itinerary Day ${i + 1} heading is required.`);
            refs.itineraryRef?.current?.scrollToAndHighlightField(day);
            return;
        }

        if (typeof day.dayDescription !== 'string' || day.dayDescription.trim() === '') {
            toast.error(`Itinerary Day ${i + 1} description is required.`);
            refs.itineraryRef?.current?.scrollToAndHighlightField(day);
            return;
        }
    }

    //so we show error if the checkIti is true
    // if (checkIti) {
    //     toast.error('Itinerary error');
    //     return;
    // }
    if ((imgData?.oldWallImg?.length || 0) + (imgData?.newWallImg?.length || 0) < 5) {
        toast.error('Upload at least 5 Wallpaper Images');
        refs.imageRef?.current?.scrollToAndHighlightField('');
        return;
    }

    if ((imgData?.oldThumbImg?.length || 0) + (imgData?.newThumbImg?.length || 0) < 2) {
        toast.error('Upload at least 2 Thumbnail Images');
        refs.imageRef?.current?.scrollToAndHighlightField('');
        return;
    }
    if (20 > tempData.included.length || tempData.included.length > 800) {
        toast.error('Add atleast 2 includes');
        refs.inExRef?.current?.scrollToAndHighlightField('included');
        return;
    }
    if (20 > tempData.excluded.length || tempData.excluded.length > 800) {
        toast.error('Add atleast 2 excludes');
        refs.inExRef?.current?.scrollToAndHighlightField('excluded');
        return;
    }
    if (20 > tempData.safety.length || tempData.safety.length > 800) {
        toast.error('Add atleast 2 safety points');
        refs.safetyRef?.current?.scrollToAndHighlightField('safety');
        return;
    }

    if (20 > tempData.carry.length || tempData.carry.length > 800) {
        toast.error('Add atleast 2 things to carry points');
        refs.thingsRef?.current?.scrollToAndHighlightField('carry');
        return;
    }

    if (packData.group === 'backpacking' && packData.datesType === 'fixed') {
        packData.price = packData.price.map((item) => ({
            ...item,
            meetupPoint: []
        }));
    }
    if (packData.datesType === 'custom') {
        packData.price = packData.price.map((item) => ({
            ...item,
            pickupLocation: [],
            price: { actual: 0, reserve: 0, tax: 0, total: 0 }
        }));
    } else if (packData.datesType === 'fixed') {
        packData.price = packData.price.map((item) => ({
            ...item,
            customPrice: {
                room: 0,
                groupPrice: 0,
                bed: 0,
                perPerson: 0,
                reserve: 0,
                vehicle: []
            }
        }));
    }

    const FAQ = packData.FAQ;
    for (let i = 0; i < FAQ.length; i++) {
        const faq = FAQ[i];

        if (typeof faq.question !== 'string' || faq.question.trim() === '') {
            toast.error(`Faq ${i + 1} question is required.`);
            refs.faqRef?.current?.scrollToAndHighlightField(`question${i}`);
            return;
        }

        if (typeof faq.answer !== 'string' || faq.answer.trim() === '') {
            toast.error(`Faq ${i + 1} answer is required.`);
            refs.faqRef?.current?.scrollToAndHighlightField(`answer${i}`);
            return;
        }
    }

    // const checkFAQ = packData.FAQ.every((item) => {
    //     return (
    //         5 > item.question.length || item.question.length > 300 || 2 > item.answer.length || item.answer.length > 500
    //     );
    // });
    // if (checkFAQ) {
    //     toast.error('FAQ error');
    //     refs.faqRef?.current?.scrollToAndHighlightField('question');
    //     return;
    // }

    if (20 > tempData.terms.length || tempData.terms.length > 800) {
        toast.error('Add atleast 1 point to terms');
        refs.termsRef?.current?.scrollToAndHighlightField('terms');
        return;
    }
    const hasPriceError = packData.price.some((item, index) => {
        const isCustom = packData.datesType === 'custom';
        const isFixed = packData.datesType === 'fixed';

        if (isCustom) {
            if (!item.customPrice) {
                toast.error(`City ${index + 1} Custom price is missing`);
                return true;
            }
            if (item.customPrice.room <= 0) {
                toast.error(`City ${index + 1}: Room price must be greater than 0`);
                return true;
            }
            if (item.customPrice.bed <= 0) {
                toast.error(`City ${index + 1}: Bed price must be greater than 0`);
                return true;
            }
            if (item.customPrice.perPerson <= 0) {
                toast.error(`City ${index + 1}: Per person price must be greater than 0`);
                return true;
            }
            if (item.customPrice.groupPrice <= 0) {
                toast.error(`City ${index + 1}: Group price must be greater than 0`);
                return true;
            }
        }

        if (isFixed) {
            if (!item.price || item.price.actual <= 0) {
                toast.error(`City ${index + 1}: Actual price must be greater than 0`);
                return true;
            }
        }

        if (!item.startCity || item.startCity.length < 2 || item.startCity.length > 30) {
            toast.error(`City ${index + 1} Start city must be between 2 and 30 characters`);
            return true;
        }

        if (packData.group === 'backpacking' && isFixed) {
            if (!item.pickupLocation || item.pickupLocation.length < 1) {
                toast.error(`City ${index + 1} Pickup location is required`);
                return true;
            }
        } else {
            if (!item.meetupPoint || item.meetupPoint.length < 1) {
                toast.error(`City ${index + 1} Meetup point is required`);
                return true;
            }
        }

        return false; // no error for this item
    });

    if (hasPriceError) {
        refs.priceRef?.current?.scrollToAndHighlightField('price');
        return; // stop submission
    }

    const checkInstallment = packData.price.every((item, itemIndex) => {
        const installments = item?.instalments || [];

        return installments.every((inst, instIndex) => {
            const hasValidComment = inst.comment && inst.comment.trim().length > 0;
            const hasValidPercentage = parseFloat(inst.percentage) > 0;

            return hasValidComment && hasValidPercentage;
        });
    });
    // if (checkPrice) {
    //     toast.error('Price error');
    //     return;
    // }
    if (!checkInstallment) {
        toast.error('All installments must have a percentage and comment.');
        return;
    }
    if (packData.tags.length < 5) {
        toast.error('You should add minimum of 5 tags');
        refs.tagsRef?.current?.scrollToAndHighlightField('tags');
        return;
    }
    const checkTags = packData.tags.every((item) => {
        return item.length > 50;
    });
    if (checkTags) {
        toast.error('One of the tags length is greater than 50');
        return;
    }
    setLoading(true);
    try {
        //insted of appending, upload the images to firebase and store links in the backend
        //User blow three lines for each file upload, You have loop and use Promise.all
        //create a function and return a downloadURL at last, Put all three lines in that function
        //upload the files to firebase and get the URL

        console.log(orgId, localStorage.getItem('selectedOrgName'), 'orgId');

        let data = {
            ...packData,
            organizerId: orgId,
            organizerName: localStorage.getItem('selectedOrgName')
        };

        let type = localStorage.getItem('type');
        // Walpaper Image Upload
        if (isEdit) {
            const uploadedNewImgs = imgData?.newWallImg?.length
                ? await Promise.all(imgData.newWallImg.map((file) => fileUpload(file, type, 'create', 'wallImg')))
                : [];
            data.images = [...(imgData.oldWallImg || []), ...uploadedNewImgs];
        } else {
            data.images = await Promise.all(
                imgData.newWallImg.map((file) => fileUpload(file, type, 'create', 'wallImg'))
            );
        }

        // Thumbnail Image Upload
        if (isEdit) {
            const uploadedNewImgs = imgData?.newThumbImg?.length
                ? await Promise.all(imgData.newThumbImg.map((file) => fileUpload(file, type, 'create', 'thumbImg')))
                : [];
            data.cardImages = [...(imgData.oldThumbImg || []), ...uploadedNewImgs];
        } else {
            data.cardImages = await Promise.all(
                imgData.newThumbImg.map((file) => fileUpload(file, type, 'create', 'thumbImg'))
            );
        }

        // Stay images — upload any new File objects, keep existing URLs
        if (data.stayDetails && Array.isArray(data.stayDetails.images)) {
            const stayImgs = await Promise.all(
                data.stayDetails.images.map((img) =>
                    img instanceof File ? fileUpload(img, type, 'create', 'stayImg') : img
                )
            );
            data.stayDetails = { ...data.stayDetails, images: stayImgs.filter(Boolean) };
        }

        // Video upload
        if (isEdit) {
            if (videoFile instanceof File) {
                if (packData?.videos?.length > 0) {
                    await deleteFile(packData.videos[0]);
                }
                const videoURL = await fileUpload(videoFile, type, 'create', 'tripVideo');
                data.videos = [videoURL];
            } else if (
                (videoFile === null || videoFile === undefined || videoFile === '') &&
                packData?.videos?.length > 0
            ) {
                await deleteFile(packData.videos[0]);
                data.videos = [];
            } else {
                data.videos = packData.videos || [];
            }
        } else {
            if (videoFile instanceof File) {
                const videoURL = await fileUpload(videoFile, type, 'create', 'tripVideo');
                data.videos = [videoURL];
            } else {
                data.videos = [];
            }
        }

        // const paData = new FormData();
        // imgData.wallImg.forEach((file) => {
        //     paData.append('images', file);
        // });
        // imgData.thumbImg.forEach((file) => {
        //     paData.append('cardImages', file);
        // });
        // for (const key in packData) {
        //     paData.append(key, packData[key]);
        // }
        //store the included/excluded in array of string, each string is a new line
        // Split the included/excluded by newlines to get new lines
        data.included = tempData.included.split('\n').filter((line) => line.trim() !== '');
        data.excluded = tempData.excluded.split('\n').filter((line) => line.trim() !== '');
        data.terms = tempData.terms.split('\n').filter((line) => line.trim() !== '');
        data.safety = tempData.safety.split('\n').filter((line) => line.trim() !== '');
        data.carry = tempData.carry.split('\n').filter((line) => line.trim() !== '');
        //convert Included and excluded into array from different lines
        //and add that to pack data

        let response;
        if (isEdit) {
            response = await supTripEdit('trip', data);
        } else {
            const { _id, ...rest } = data;
            response = await supTripCreateFun('trip', rest);
        }

        if (response.status === 200) {
            toast.success(`Package ${isEdit ? 'updated' : 'created'} successfully`);
            setLoading(false);
            return response.status;
        }
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
}
